import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import { url, sitename } from '../../../config';
import CurrencyView from '../modules/CurrencyView';

class CancelledByHost extends Component {
  static propTypes = {
    content: PropTypes.shape({
      hostName: PropTypes.string.isRequired,
      guestName: PropTypes.string.isRequired,
      checkIn: PropTypes.string.isRequired,
      confirmationCode: PropTypes.number.isRequired,
      listTitle: PropTypes.string.isRequired,
      refundToGuest: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    content: {
      refundToGuest: 0,
    },
  };

  render() {
    const textStyle = {
      color: '#484848',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Proxima Nova',
      fontSize: '16px',
      padding: '35px',
    };
    const textInlineStyle = {
      color: '#484848',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Proxima Nova',
      fontSize: '16px',
    };

    const {
      content: {
        guestName,
        hostName,
        confirmationCode,
        checkIn,
        listTitle,
        refundToGuest,
        currency,
      },
    } = this.props;
    let checkInDate =
      checkIn != null ? moment.utc(checkIn).format('ddd, Do MMM, YYYY') : '';

    return (
      <Layout>
        <Header color="#159CE9" backgroundColor="#F7F7F7" />
        <div>
          <Table width="100%">
            <TBody>
              <TR>
                <TD style={textStyle}>
                  <EmptySpace height={20} />
                  <div>Hello,</div>
                  <EmptySpace height={20} />
                  <div style={textInlineStyle}>
                    We regret to inform you that the your reservation on{' '}
                    {checkInDate} for {listTitle} has been cancelled.{' '}
                    Confirmation Code: {confirmationCode}.{' '}
                  </div>
                  <div style={textInlineStyle}>
                    Refunds will be issued based on the cancellation policy.
                  </div>
                  <EmptySpace height={40} />
                  <div style={textInlineStyle}>
                    Regards, <br />
                    The {sitename} Team
                  </div>
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={40} />
        </div>
        <Footer />
        <EmptySpace height={20} />
      </Layout>
    );
  }
}

export default CancelledByHost;



// WEBPACK FOOTER //
// ./src/core/email/template/CancelledByHost.js